import { FacebookRounded, Menu, Twitter } from '@mui/icons-material'
import { AppBar, Box, Grid, Toolbar } from '@mui/material'
import { Link } from 'react-router-dom'
import Logo from 'src/assets/logo.png'
import { lightBlue } from 'src/utils/colors'
import { navItems } from './enums'
import NavItem from './NavItem'

interface propTypes {
  openSidebar: boolean
  handleSidebar: () => void
}
const Header: React.FC<propTypes> = ({ handleSidebar }) => {
  return (
    <Box sx={{ flexGrow: '1' }}>
      <AppBar
        position="fixed"
        sx={{
          height: { xs: '56px', md: '65px' },
          backgroundColor: '#fff',
          borderBottom: `1px solid ${lightBlue}`,
          maxWidth: '1600px',
          mx: 'auto',
          right: 'initial',
          px: { xs: 2, md: 4 },
        }}
        elevation={0}
      >
        <Toolbar>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={2}>
              <Link to="/">
                <Box sx={{ maxHeight: '40px' }}>
                  <img
                    src={Logo}
                    alt="InfoGIS Logo"
                    style={{ maxHeight: '40px' }}
                  />
                </Box>
              </Link>
            </Grid>
            <Grid item xs={4.5} sx={{ display: { xs: 'none', md: 'initial' } }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  '> a > li': {
                    fontWeight: '600',
                    fontSize: '1.3rem',
                    fontFamily: 'Myriad Pro Bold',
                  },
                  '> button': {
                    fontWeight: '600',
                    fontSize: '1.3rem',
                    fontFamily: 'Myriad Pro Bold',
                  },
                  '> .active': {
                    borderBottom: `2px solid ${lightBlue}`,
                  },
                }}
              >
                {navItems.map((item, index) => (
                  <NavItem {...item} key={index}>
                    {item.title}
                  </NavItem>
                ))}
              </Box>
            </Grid>
            <Grid item xs={2} sx={{ display: { xs: 'none', md: 'initial' } }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Box
                  component="a"
                  href="https://www.facebook.com/"
                  target="_blank"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s',
                    '> .MuiSvgIcon-root': {
                      fill: '#fff',
                      transition: 'all 0.2s',
                    },
                    ':hover': {
                      backgroundColor: '#fff',
                      '> .MuiSvgIcon-root': {
                        fill: lightBlue,
                      },
                    },
                    backgroundColor: lightBlue,
                    borderRadius: '20px',
                    border: `1px solid ${lightBlue}`,
                    p: 0.5,
                    mr: 2,
                    height: 'fit-content',
                  }}
                >
                  <FacebookRounded fontSize="small" />
                </Box>
                <Box
                  component="a"
                  href="https://www.twitter.com/"
                  target="_blank"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s',
                    '> .MuiSvgIcon-root': {
                      fill: '#fff',
                      transition: 'all 0.2s',
                    },
                    ':hover': {
                      backgroundColor: '#fff',
                      '> .MuiSvgIcon-root': {
                        fill: lightBlue,
                      },
                    },
                    backgroundColor: lightBlue,
                    borderRadius: '20px',
                    border: `1px solid ${lightBlue}`,
                    p: 0.5,
                    height: 'fit-content',
                  }}
                >
                  <Twitter fontSize="small" />
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={2}
              sx={{
                display: { xs: 'flex', md: 'none' },
                justifyContent: 'end',
              }}
            >
              <Box display="flex" onClick={handleSidebar}>
                <Menu color="primary" />
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default Header
